import {
  actions,
  getAllNarratorsAsync,
  getNarratorsAsDataTableAsync,
  getNarratorsLookUpsAsync,
  createNewNarratorAsync,
  editNarratorAsync,
  deleteNarratorAsync,
  getDefaultNarratorAsync,
  createNarratorMultilingualAsync,
  editNarratorMultilingualAsync,
  getNarratorByIdMultilingualAsync,
} from './slices';

export const NarratorActions = {
  ...actions,
  getAllNarratorsAsync,
  getNarratorsAsDataTableAsync,
  getNarratorsLookUpsAsync,
  createNewNarratorAsync,
  editNarratorAsync,
  deleteNarratorAsync,
  getDefaultNarratorAsync,
  createNarratorMultilingualAsync,
  editNarratorMultilingualAsync,
  getNarratorByIdMultilingualAsync,
};

export * from './thunkHandlers';
